<div class="cell-inner">
  @for (delivery of sortedDeliveries(); track delivery.id) {
    <div class="block-slot">
      <delivery-block
        [delivery]="delivery"
        [color]="getColor(delivery)"
        (blockClick)="deliveryClick.emit($event)"
      />
    </div>
  }
</div>
